@if (smartphoto) {
  <bdeo-card routerLink="{{ '/smartphoto/' + smartphoto.id }}">
    <div class="card">
      <!-- Header -->
      <div class="card__header">
        @if (hasDeadline$ | async) {
          <div class="card__header-date">
            <span class="card__date-label">{{ 'deadline' | i18nextEager }}</span>
            @if (smartphoto.deadlineSelfadjust?.toLowerCase() === 'invalid date') {
              <span class="card__date-value">{{ 'invalid_date' | i18nextEager }}</span>
            } @else {
              <span class="card__date-value">{{ smartphoto.deadlineSelfadjust }}</span>
            }
          </div>
        } @else {
          <div class="card__header-date">
            <span class="card__date-label">{{ 'created_at' | i18nextEager }}</span>
            <!-- TO DO Tal vez formatear mejor la fecha-->
            @if (smartphoto.createdAt) {
              <span class="card__date-value">{{ smartphoto.createdAt * 1000 | date: 'dd/MM/yy' }}</span>
            } @else {
              <span class="card__date-value">-</span>
            }
          </div>
        }
        @if (this.smartphotoStatusDetails; as statusDetail) {
          <bdeo-tag
            class="card__header-tag"
            size="medium"
            text="{{ 'statuses.' + statusDetail.lang | i18nextEager }}"
            color="{{ statusDetail.color }}"
            icon="{{ statusDetail.icon }}"
          ></bdeo-tag>
        }
      </div>

      <!-- Fields -->
      @if (cardFields.length) {
        @for (field of cardFields; track $index) {
          <div class="card__fields-row">
            <div class="card__fields-label">
              <span>{{ field.fieldDescription }}</span>
            </div>
            <div class="card__fields-value">
              <span>{{ field.value }}</span>
            </div>
          </div>
        }
      } @else {
        @if (smartphoto.caseRef) {
          <div class="card__fields-row">
            <div class="card__fields-label">
              <span>{{ 'claim_number' | i18nextEager }}</span>
            </div>
            <div class="card__fields-value">
              <span>{{ smartphoto.caseRef }}</span>
            </div>
          </div>
        }

        @if (smartphoto.vehicleType) {
          <div class="card__fields-row">
            <div class="card__fields-label">
              <span>{{ 'vehicle_type' | i18nextEager }}</span>
            </div>
            <div class="card__fields-value">
              <span>{{ 'vehicle_types.' + smartphoto.vehicleType | i18nextEager }}</span>
            </div>
          </div>
        }

        @if (smartphoto.plate) {
          <div class="card__fields-row">
            <div class="card__fields-label">
              <span>{{ 'plate' | i18nextEager }}</span>
            </div>
            <div class="card__fields-value">
              <span>{{ smartphoto.plate }}</span>
            </div>
          </div>
        }
      }
    </div>
  </bdeo-card>
}
